import React from 'react/lib/ReactWithAddons';
import { Link } from 'react-router';
import { serverCache, Error } from '../data/server';


export const Help = React.createClass({
    listLinks(links) {
        return <ul className="list-group">
            { Object.keys(links).map((key, index) => (
                !links[key][0] ? false :
                <li className="list-group-item" key={index}>
                    <Link to={links[key][0]} target={(links[key][2] || "") != 'local' ? "_blank" : ""} key={index}><i className={"fa " + links[key][1]}></i> {key}</Link>
                </li>
            ))}
            </ul>
    },

    render() {
        const info = serverCache.getInfo();
        const helplinks = info.get('help_links', new Map);
        const links = {
            'What is B2INST?': ['/help/docs', 'fa-list', 'local'],
            'User Guide': [helplinks.get('user-guide'), 'fa-file'],
            'Search': [helplinks.get('search'), 'fa-info-circle'],
            'REST API': [helplinks.get('rest-api'), 'fa-info-circle'],
            'Terms of Use': [info.get('terms_of_use_link'), 'fa-question-circle'],
            'Report an issue': [helplinks.get('issues'), 'fa-exclamation-circle']
        }

        return (
            <div className="help-page">
                <h1>Help</h1>
                <div className="container-fluid">
                    <div className="col-sm-6">
                        {this.listLinks(links)}
                    </div>
                </div>
            </div>
        );
    }
});

export const Docs = React.createClass({
    render() {
        return (
            <div className="help-page">
                <h1>B2INST documentation</h1>
                <h2>What is B2INST?</h2>
                <div className="container-fluid">
                    <div className="col-sm-6">
                        <p>B2INST is a service that enables researchers and institute to register their instruments and to be able to persistently refer to these registrations in other services or publications.</p>
                        <p>The service is currently only a proof-of-concept and is bound to change or be unavailable without further notice.</p>
                    </div>
                </div>
                <h2>Who maintains B2INST?</h2>
                <div className="container-fluid">
                    <div className="col-sm-6">
                        B2INST in its current state is maintained by EUDAT Ltd., DataCite and the ePIC consortium.
                    </div>
                </div>
                <h2>Who can use B2INST?</h2>
                <div className="container-fluid">
                    <div className="col-sm-6">
                        B2INST can be used by anyone who is interested in registration of instruments.
                    </div>
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/help.jsx